import { ApiGet } from "../../helpers/API/ApiData";

export type Props = {
  page: number;
  countPerPage: number;
  search?: string;
  setLoadingData: (value: React.SetStateAction<boolean>) => void;
  setPage: (value: React.SetStateAction<number>) => void;
  setCountPerPage: (value: React.SetStateAction<number>) => void;
  setData: (value: React.SetStateAction<any[]>) => void;
  setCount: (value: React.SetStateAction<number>) => void;
};

export const getItems = async ({
  page,
  countPerPage,
  search,
  setLoadingData,
  setPage,
  setCountPerPage,
  setData,
  setCount,
}: Props) => {
  try {
    setLoadingData(true);

    const params = `page=${page}&limit=${countPerPage}${search ? `&letter=${search}` : ""}`;
    const response = await ApiGet(`news/find?${params}`);

    setLoadingData(false);
    setPage(page);
    setCountPerPage(countPerPage);
    setCount(response?.data?.count ?? 0);
    setData((response?.data?.data as any[]) ?? []);
  } catch (error) {
    setLoadingData(false);
  }
};
